/**
 * Segmented tab control. Maps to the existing App.css .tabs / .tab classes.
 *
 * Props:
 *   tabs      — Array<{ key: string, label: string }>
 *   activeKey — key of the currently selected tab
 *   onChange  — (key: string) => void
 *   className — extra class(es) on the tablist container
 *
 * All other props pass through to the root <div role="tablist">.
 */
export default function Tabs({ tabs, activeKey, onChange, className = '', ...props }) {
  return (
    <div
      className={['tabs', className].filter(Boolean).join(' ')}
      role="tablist"
      {...props}
    >
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={activeKey === tab.key}
          className={['tab', activeKey === tab.key ? 'tab-active' : ''].filter(Boolean).join(' ')}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
